<template>
  <v-text-field
    data-testid="price-input"
    :value="displayValue"
    @input="onInput"
    @keydown="blockNonNumeric"
    @keydown.enter.prevent="$emit('submit')"
    maxlength="6"
    height="80"
    class="py-0 my-0"
    style="font-size: 3rem"
  />
</template>

<script>
export default {
  props: {
    quote: {
      type: [String, Number],
      default: ""
    }
  },

  data() {
    return {
      digits: ""
    }
  },

  computed: {
    displayValue() {
      if (!this.digits) return ""

      if (this.digits.length === 1) {
        return this.digits
      }

      return `${this.digits[0]}.${this.digits.slice(1)}`
    }
  },

  watch: {
    quote: {
      immediate: true,
      handler(value) {
        this.digits = String(value || "").replace(/\D/g, "").slice(0, 5)
      }
    }
  },

  methods: {
    onInput(value) {
      this.digits = String(value || "").replace(/\D/g, "").slice(0, 5)

      this.$emit("update:quote", this.displayValue)
    },

    blockNonNumeric(e) {
      const allowed = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Escape",
        "Enter",
        "Tab"
      ]

      if (allowed.includes(e.key) || e.metaKey || e.ctrlKey) return

      if (!/^\d$/.test(e.key)) {
        e.preventDefault()
      }
    }
  }
}
</script>